import uk from './en-GB';
import au from './en-AU';
import nz from './en-NZ';
import dk from './da-DK';
import es from './es-ES';
import ie from './en-IE';
import no from './nb-NO';

const tenantConfigs = {
    'en-GB': uk,
    'en-AU': au,
    'en-NZ': nz,
    'da-DK': dk,
    'es-ES': es,
    'en-IE': ie,
    'nb-NO': no
};

export default tenantConfigs;
